 export const mixin = {
    methods:{
        generateId() {
            return (
              "_" +
              Math.random()
                .toString(36)
                .substr(2, 9)
            );
          }, 
          getSvgUrl(name,path) {
            return require(`../assets/${path}/${name}.jpg`);
          },
          change(obj) {
            if (obj.type == "camo") {
              this.color = `url(#${obj.name})`;
              this.colorName = obj.name;
              this.colortype = "camo";
            } else if (obj.type == "print") {
              this.color = `url(#${obj.name})`;
              this.colorName = obj.name;
              this.colortype = "print";
            } else {
              this.color = obj.color;
              this.colorName = obj.name;
              this.colortype = "pure";
            }
            this.panel = [];
          },
    }
}